import {createRoot} from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import {Provider} from 'react-redux';
import * as serviceWorker from 'serviceWorker';
import App from 'App';
import {store} from 'store';

// style + assets
import 'assets/scss/style.scss';
import config from './config';
import {AuthProvider} from "./context/AuthContext";
import { TenantProvider } from './context/TenantContext';

// ==============================|| REACT DOM RENDER  ||============================== //

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <Provider store={store}>
        <TenantProvider>
            <AuthProvider>
                <BrowserRouter basename={config.basename}>
                    <App/>
                </BrowserRouter>
            </AuthProvider>
        </TenantProvider>
    </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
